module.exports = __webpack_public_path__ + "assets/media/announcer_ment_information_5.5da7bda3.mp3";